<template>
	<div class="request">
		<div class="request__title">
			<div class="request__head">
				{{ request.title }}
				<span class="request__num">{{ request.count }}</span>
			</div>
			<button class="request__btn" @click="handleMore">더보기 +</button>
		</div>
		<div class="request__content">
			<div
				class="request__list"
				v-for="(item, index) in requestData"
				:key="index"
			>
				<span class="request__item">
					<router-link
						:to="`${request.productLink}?cspId=${Number(item.id)}`"
						>{{ item.body }}</router-link
					>
				</span>
				<span class="request__date">{{
					computedDate(item.updatedAt)
				}}</span>
			</div>
		</div>
	</div>
</template>
<script>
	import { durationText } from '../../util';

	export default {
		props: {
			request: {
				type: Object,
				required: true,
			},
		},
		methods: {
			handleMore() {
				this.$router.push(`${this.request.moreLink}`);
			},
			computedDate(date) {
				return durationText(date);
			},
		},
		computed: {
			requestData() {
				return this.request.data ? this.request.data.slice(0, 5) : [];
			},
		},
	};
</script>
<style lang="scss" scoped>
	.request {
		width: 100%;
		max-width: 980px;
		border: 1px solid #dfe6ee;
		border-radius: 10px;
		margin-top: 20px;
		padding: 10px;
		height: 270px;
		&__title {
			font-size: 15px;
			padding: 5px 20px;
			display: flex;
			justify-content: space-between;
			align-items: center;
			border-bottom: 1px solid #a7acb2;
		}
		&__num {
			display: inline;
			padding: 5px;
			margin-left: 5px;
			margin-bottom: 10px;
			font-weight: bold;
			color: #fff;
			border-radius: 30%;
			background-color: rgb(255, 68, 68);
		}
		&__head {
			font-weight: bold;
		}
		&__list {
			width: 100%;
			font-size: 14px;
			padding: 10px;
			display: flex;
			justify-content: space-between;
			align-items: center;
			gap: 40px;
			& + & {
				border-top: 1px solid #dfe6ee;
			}
		}

		&__content {
			width: 100%;
		}
		&__btn {
			color: #007bff;
			padding: 5px;
			border-radius: 10px;
		}

		&__item {
			width: 100%;
			color: #007bff;
			text-decoration: none;
			cursor: pointer;
			overflow: hidden;
			white-space: nowrap;
			text-overflow: ellipsis;
			flex: 1 0 0;
		}
	}
</style>
